import { getAllMlsListInfo } from "../../service/service-gateway";

export const actions = () => ({
    getMlsList: async () => {
        try {
            return await getAllMlsListInfo();
        } catch (err) {
            throw new Error(`MLS list fetch error: ${err}`);
        }
    },
});
